module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/chapel_sns_01-b3ff1c9f5fd6b7b251d848314ab108fe.jpg";